import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import DOMPurify from "dompurify";

import { selectNotice } from "../features/global/globalSlice";
import { useAppSelector } from "../hooks/reduxHooks";

const SiteNotice = (): React.ReactNode => {
    const notice = useAppSelector(selectNotice);
    const now = new Date();
    const endOfDay = notice ? new Date(notice.lastUpdated) : null;
    endOfDay?.setHours(23, 59, 29, 999);

    if (
        !notice ||
        notice.notice.trim().length === 0 ||
        (endOfDay ? now > endOfDay : false)
    )
        return null;

    return (
        <div id="siteNotice">
            <Container fluid="lg">
                <Row>
                    <Col xs={{ span: 8, offset: 2 }}>
                        <div
                            className="notice alert alert-warning"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(notice.notice),
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default SiteNotice;
